import { useEffect } from 'react';

const paramsToRemove = ['refSource'];

export default function useRemoveQueryParams() {
  useEffect(() => {
    const url = new URL(window.location.href);

    [...url.searchParams.keys()].forEach(param => {
      if (paramsToRemove.includes(param)) {
        url.searchParams.delete(param);
      }
    });

    if (window.location.href !== url.toString()) {
      window.history.replaceState({}, '', url.toString());
    }
  }, []);
}
